import Intl from '~/Intl'

import { useStoreContext } from '../../CurrentStoreProvider'

const StoreIntl: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { data } = useStoreContext()
  return <Intl locale={data?.attributes.locale}>{children}</Intl>
}

export default StoreIntl
